import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import './Button.css';

type ButtonProps = {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', ...props }) => {
  return (
    <button
      className={`custom-button ${variant === 'primary' ? 'primary' : 'secondary'}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
